module.exports = __webpack_public_path__ + "static/media/puc-only-desktop.d97ef14b.svg";